module.exports = __webpack_public_path__ + "assets/img/unblockIcon.7ed35792.svg";